<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="ex-ctr"><span class="epub-b">I really need to thank:</span></p>
<p class="gl">“El Pulpo,” for fixing my computer, sharing information about South American folklore, and most of all, cooking for me.</p>
<p class="gl">Juan Pablo, for sharing information about South American folklore and doing the dishes.</p>
<p class="gl">Raffaele, for the gnocchi, frutti di bosco, and panettone.</p>
<p class="gl">Adriana Groisman, for sharing information about Argentine politics and her husband Alberto’s cooking.</p>
<p class="gl">My automatic writing partners:</p>
<p class="v">Alina Troyano, for writing with me and cooking for me.</p>
<p class="v">Madeleine Olnek, for writing with me and cooking for me on the fabulous Ronco Showtime Rotisserie Oven.</p>
<p class="v">Shirley Kwan, for writing with me and cooking for me.</p>
<p class="v">Carol McCurdy, for writing with me and cooking for me.</p>
<p class="gl">Broadway, Pywackett and Kishka, for being great company.</p>
<p class="gl">Nicki, Garbo 180, and the Goddess, for bringing me luck and inspiration.</p>
<p class="gl">iMac, for cooking with me.</p>
<p class="gl">Vivian and Alejandra, for their scary witch stories and cooking for me on the Ronco Showtime Rotisserie Oven.</p>
<p class="gl">Jennifer Enderlin, Sandra Martin, Lisa Hagen—even tho’ you never cooked for me, you have taken me out for lunch and dinner. I deeply appreciate the opportunities you have given me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?7e13864e